import _ from "lodash";
import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { BeatLoader } from "react-spinners";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import { DateHelper } from "../../helper/helpers";
import { createClass } from "../../redux/actions/api/apiAction";
import { setForceAddModalOpen } from "../../redux/actions/class/classAction";
import { getClassDatesObject } from "./utils";

export const ForceAddModal = ({ values }) => {
  const dispatch = useDispatch();
  const { trainer: selectedTrainer } = useSelector((state) => state.trainer);

  const toggle = () => {
    dispatch(setForceAddModalOpen(!forceAddModalOpen));
  };

  const handleForceAddClass = () => {
    let {
      bookingWindowEnd,
      bookingWindowStart,
      startDate,
      endDate,
      classDates,
      bookingStartUnit,
      bookingEndUnit,
      trainer,
      cancelBefore,
      timesArray
    } = values;
    const { scheduleDays } = selectedTrainer;
    let datesObj = {};
    const classDays = classDates.map((date) => {
      let dayString = DateHelper.GetFullDayString(parseInt(date));
      let arr = [];
      for (let i = 0; i < timesArray.length; i++) {
        const element = timesArray[i];
        arr.push({
          start: element.from,
          end: element.to,
        });
      }
      datesObj[dayString] = arr;
      arr = [];
      return dayString;
    });

    const datesToSend = [startDate, endDate].map((item) => item.getTime());
    let timeForDates = [];

    let correctDateTimes = values.classDates.map((date) => {
      let dateString = moment(date).format("DD/MM/yyyy");
      for (let index = 0; index < timesArray.length; index++) {
        const element = timesArray[index];
        timeForDates.push({
          from: parseInt(
            moment(dateString + " " + element.from, "DD/MM/yyyyLT").format("x")
          ),
          to: parseInt(
            moment(dateString + " " + element.to, "DD/MM/yyyyLT").format("x")
          ),
        });
      }
    });

    let datesWithBookings = getClassDatesObject(
      bookingWindowStart,
      bookingWindowEnd,
      timeForDates,
      bookingStartUnit,
      bookingEndUnit,
      cancelBefore
    );
    values.classDates = datesWithBookings;
    let req = _.cloneDeep(values);
    [("startDate", "endDate")].forEach((item, idx) => {
      req[item] = datesToSend[idx];
    });
    req.startDate = datesToSend[0];
    req.endDate = datesToSend[1];
    dispatch(setForceAddModalOpen(false));

    dispatch(createClass(req));
  };

  const { forceAddModalOpen } = useSelector((state) => state.class);

  return (
    <Modal centered isOpen={forceAddModalOpen} toggle={toggle}>
      <ModalBody className="px-5 pt-2 pb-4">
        <div className="d-flex justify-content-center align-items-center flex-column py-3 text-center">
          <h4>Class times are not withen trainer's schedule</h4>
          <h4>Do you wish to add anyway ?</h4>

          <Row className="mt-3">
            <Col xs={6}>
              <button
                onClick={handleForceAddClass}
                type="button"
                className="btn btn-small"
              >
                Add
              </button>
            </Col>
            <Col xs={6}>
              <button
                onClick={toggle}
                type="button"
                className="btn btn-small btn-danger"
              >
                Cancel
              </button>
            </Col>
          </Row>
        </div>
      </ModalBody>
    </Modal>
  );
};
